import { useEffect } from 'react'
import { useAuditTrail } from './use-audit-trail'

export function useResetAuditTrailOnUnmount() {
  const { resetToInitialFilters } = useAuditTrail()

  useEffect(() => {
    return () => {
      resetToInitialFilters()
    }
  }, [resetToInitialFilters])
}
